<app-loading *ngIf="loading"></app-loading>
<section *ngIf="game && !loading" [innerHTML]="Sanitiser.bypassSecurityTrustHtml(game.options.html)"></section>